module.exports = __webpack_public_path__ + "static/media/leadloop.53ad5bab.svg";